/**
 * Generic admin-portal list repository (infrastructure layer).
 *
 * Every read-only admin endpoint returns the same DataTable envelope
 * (rows + total + nextCursor). Rather than write 7 nearly-identical
 * repositories, we expose one factory keyed by URL.
 */
import type { AxiosInstance } from 'axios';

import type { ListPage, ListParams } from '@domain/customer/CustomerRepository';

import { ADMIN_API_BASE } from './client';

export class AdminListRepository<T> {
  constructor(
    private readonly api: AxiosInstance,
    private readonly path: string, // e.g. 'messages', 'invoices'
  ) {}

  async list(params: ListParams): Promise<ListPage<T>> {
    const query: Record<string, string | number> = { limit: params.limit };
    if (params.offset !== undefined) query.offset = params.offset;
    if (params.cursor) query.offset = Number(params.cursor);
    if (params.sort) query.sort = (params.sort.desc ? '-' : '') + params.sort.id;
    if (params.filters) {
      for (const [k, v] of Object.entries(params.filters)) query[k] = String(v);
    }
    const r = await this.api.get(`${ADMIN_API_BASE}/${this.path}/`, { params: query });
    return r.data as ListPage<T>;
  }
}
